import { Cart } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { COOKIES_NAMES, getActiveCartId, removeCookie, setCookie } from '../../../helpers';
import { Context } from '@vue-storefront/core';

export function setCart(
  context: Context,
  newCart: Cart | null,
  useCartId?: string
): Cart {
  const {
    $sapcc: {
      config: { $cookies }
    }
  } = context;

  if (!useCartId) return newCart;

  const cartCookieName = `${COOKIES_NAMES.CART_ID}-${useCartId}`;

  if (!newCart) {
    removeCookie({ cookies: $cookies, name: cartCookieName });
  } else {
    setCookie({
      cookies: $cookies,
      name: cartCookieName,
      value: getActiveCartId({ cookies: $cookies, currentCart: newCart })
    });
  }

  return newCart;
}
